export interface IRegistrationDetailsForChart {
    id: string;
    name: string;
    answers: number;
    show: boolean;
    chart: IChart[];
    attendeeAnswers: IAttendeeAnswer[];
    xScaleMax: number;
}

export class RegistrationDetailsForChart implements IRegistrationDetailsForChart {
    constructor(
        public id: string,
        public name: string,
        public answers: number,
        public show: boolean,
        public chart: IChart[],
        public attendeeAnswers: IAttendeeAnswer[],
        public xScaleMax: number
    ) { }
}

export interface IChart {
    name: string;
    value: number;
}

export class Chart implements IChart {
    constructor(
        public name: string,
        public value: number
    ) { }
}

export interface IMultiSeriesChart {
    name: string;
    series: Chart[];
}

export class MultiSeriesChart implements IMultiSeriesChart {
    constructor(public name: string, public series: Chart[]) {}
}

export interface IAttendeeAnswers {
    name: string;
    isFreeText: boolean;
    answers: IAttendeeAnswer[];
}

export class AttendeeAnswers implements IAttendeeAnswers {
    constructor(
        public name: string,
        public isFreeText: boolean,
        public answers: IAttendeeAnswer[]
    ) { }
}

export interface IAttendeeAnswer {
    firstName: string;
    lastNamePrefix: string;
    lastName: string;
    ticketHolderFirstName: string;
    ticketHolderLastName: string;
    isInvitee: boolean;
    contactFirstName: string;
    contactLastNamePrefix: string;
    contactLastName: string;
    contactMobile: string;
    contactCompany: string;
    email: string;
    mobile: string;
    company: string;
    answer: string;
    optionId: string;
}

export class AttendeeAnswer implements IAttendeeAnswer {
    constructor(
        public firstName: string,
        public lastNamePrefix: string,
        public lastName: string,
        public ticketHolderFirstName: string,
        public ticketHolderLastName: string,
        public isInvitee: boolean,
        public contactFirstName: string,
        public contactLastNamePrefix: string,
        public contactLastName: string,
        public contactMobile: string,
        public contactCompany: string,
        public email: string,
        public mobile: string,
        public company: string,
        public answer: string,
        public optionId: string
    ) { }
}
